import Phaser from 'phaser'
import { CombatSystem } from '../systems/CombatSystem'

export class CombatInput {
  private scene: Phaser.Scene
  private combatSystem: CombatSystem
  private camera: Phaser.Cameras.Scene2D.Camera

  // Track if pointer is in joystick area (to avoid accidental targeting)
  private joystickAreaWidth: number

  constructor(
    scene: Phaser.Scene,
    combatSystem: CombatSystem,
    camera: Phaser.Cameras.Scene2D.Camera
  ) {
    this.scene = scene
    this.combatSystem = combatSystem
    this.camera = camera

    // Joystick area is left half of screen (matching VirtualJoystick)
    this.joystickAreaWidth = scene.scale.width * 0.5

    this.setupInput()
  }

  private setupInput(): void {
    // Listen for pointer down events
    this.scene.input.on('pointerdown', this.handlePointerDown, this)

    // Update joystick area width on resize
    this.scene.scale.on('resize', () => {
      this.joystickAreaWidth = this.scene.scale.width * 0.5
    })
  }

  private handlePointerDown(pointer: Phaser.Input.Pointer): void {
    // Ignore if in joystick area (left side of screen)
    if (pointer.x < this.joystickAreaWidth && pointer.y > this.scene.scale.height * 0.3) {
      return
    }

    // Convert screen coordinates to world coordinates
    const worldPoint = this.camera.getWorldPoint(pointer.x, pointer.y)

    // Try to target creature at this position
    const creature = this.combatSystem.targetAtPosition(worldPoint.x, worldPoint.y)

    // If no creature tapped, clear target
    if (!creature) {
      this.combatSystem.clearTarget()
    }
  }

  /**
   * Clean up input listeners
   */
  public destroy(): void {
    this.scene.input.off('pointerdown', this.handlePointerDown, this)
  }
}
